import React, {useState} from 'react';
import {
  Form, theme, ConfigProvider, Space, Result, Button
} from 'antd';
import Axios from 'axios';
import moment from 'moment';
import { useViewport } from '../Components/Viewport';
import QuoteForm from '../Components/Form/QuoteForm';
import { FormTheme } from '../Components/Form/FormTheme';
import beemascaffold from '../Images/beemascaffold.jpeg'
import beemascaffold2 from '../Images/beemascaffold2.jpeg'

const GetQuote = () => {
  const [form] = Form.useForm();
  const [isPurchaseDateDisabled, setPurchaseDateDisabled] = useState(false);
  const [isRentalDateDisabled, setRentalDateDisabled] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [isPurchase, togglePurchase] = useState(true);
  const [isSingleWidth, selectSingleWidth] = useState(true);
  const [showResult, setShowResult] = useState(false);
  const [isSuccess, setSuccess] = useState(true);
  const { screenWidth, screenHeight } = useViewport();
  const breakpoint = 880;

  // Services state
  const [isTransportationChecked, setIsTransportationChecked] = useState(false);
  const [isAssemblyDismantleChecked, setIsAssemblyDismantleChecked] = useState(false);
  const [isEndorsementChecked, setIsEndorsementChecked] = useState(false);
  const [siteAddress, setSiteAddress] = useState('');

  const toggleWidth = (e) => {
    if((e.target.value) === 'double') {
      selectSingleWidth(false);
    } else {
      selectSingleWidth(true);
    }
  };
  const onEquiryRadioChange = (e) => {
    const value = e.target.value;
    if (value === 'purchase') {
      togglePurchase(true);
    } else {
      togglePurchase(false);
    }
  };

  const onCheckboxPurchaseChange = () => {
    setPurchaseDateDisabled(!isPurchaseDateDisabled)
    setRentalDateDisabled(isRentalDateDisabled)
    if(!isPurchaseDateDisabled) {
      form.setFields([
        {
          name: "datePurchase", // required
          value: undefined, //optional
          errors: undefined,
        },
      ]);
    }
  };

  const onCheckboxRentalChange = (e) => {
    setRentalDateDisabled(!isRentalDateDisabled)
    setPurchaseDateDisabled(isPurchaseDateDisabled)
    if(!isRentalDateDisabled) {
      form.setFields([
        {
          name: "dateRental", // required
          value: undefined, //optional
          errors: undefined,
        },
      ]);
    }
  };

  // Services change handlers
  const onTransportationChange = (e) => {
    const checked = e.target.checked;
    setIsTransportationChecked(checked);
    
    // If transportation is unchecked, automatically uncheck assembly/dismantle
    if (!checked) {
      setIsAssemblyDismantleChecked(false);
      setSiteAddress(''); // Clear site address when transportation is unchecked
    }
  };

  const onAssemblyDismantleChange = (e) => {
    const checked = e.target.checked;
    // Only allow checking if transportation is checked
    if (isTransportationChecked) {
      setIsAssemblyDismantleChecked(checked);
    }
  };

  const onEndorsementChange = (e) => {
    setIsEndorsementChecked(e.target.checked);
  };

  const onSiteAddressChange = (e) => {
    setSiteAddress(e.target.value);
  };


  const convertDatetoString = (date) => (
    moment(date).format('YYYY-MM-DD').toString()
  )

  const onFinish = (values) => {
    setLoadings(true);
    sendEmail(values);

  };

  const toggleShowResult = () => {
    setShowResult(false);
    // Reset services state when starting a new request
    setIsTransportationChecked(false);
    setIsAssemblyDismantleChecked(false);
    setIsEndorsementChecked(false);
    setSiteAddress('');
  };

  const sendEmail = (formData) => {
    let dateRentalArr = '';
    let purchaseDateStr = '';
    let purchaseCheckboxBool = '';
    
    // Handle rental dates - convert to ISO format array or empty string
    if (typeof formData.dateRental !== 'undefined' && formData.dateRental) {
      dateRentalArr = [convertDatetoString(formData.dateRental[0]?.$d), convertDatetoString(formData?.dateRental[1]?.$d)];
    }
    
    // Handle purchase date - convert to ISO format or empty string
    if (typeof formData.datePurchase !== 'undefined' && formData.datePurchase) {
      purchaseDateStr = convertDatetoString(formData.datePurchase?.$d);
    }
    
    // Handle purchase checkbox - boolean or empty string based on enquiry type
    if (formData.enquiryType === 'purchase') {
      purchaseCheckboxBool = isPurchaseDateDisabled;
    }
    
    const currTimestamp = moment().format('DD-MM-YYYY HH:mm:ss').toString();
    
    // Create clean data structure with conditional fields
    const formDataFormatted = {
      name: formData.name || '',
      email: formData.email || '',
      phone: formData.phone || '',
      companyName: formData.companyName || '',
      enquiryType: formData.enquiryType || '',
      products: formData.products || [],
      message: formData.message || '',
      timestamp: currTimestamp,
      // Conditional date/duration fields based on enquiry type
      datePurchase: formData.enquiryType === 'purchase' ? purchaseDateStr : '',
      purchaseCheckbox: formData.enquiryType === 'purchase' ? purchaseCheckboxBool : '',
      dateRental: formData.enquiryType === 'rental' ? dateRentalArr : '',
      dateDuration: formData.enquiryType === 'rental' ? (formData.dateDuration || '') : '',
      durationType: formData.enquiryType === 'rental' ? (formData.durationType || '') : '',
      // Services data
      services: {
        transportation: isTransportationChecked,
        assemblyDismantle: isAssemblyDismantleChecked,
        endorsement: isEndorsementChecked,
        siteAddress: siteAddress || ''
      }
    }
    Axios.post(
      'https://us-central1-beemascaffoldingsg.cloudfunctions.net/submit',
      formDataFormatted
    )
      .then(res => {
        form.resetFields();
        setLoadings(false);
        if (res.status === 200) {
          setSuccess(true);
        } else {
          setSuccess(false);
        }
        setShowResult(true);
      })
      .catch(error => {
        setLoadings(false);
        setSuccess(false);
        setShowResult(true);
      })
  }
  return (
    <div 
      style={{
        backgroundImage: (screenWidth > 1035) ? `url(${beemascaffold})` : `url(${beemascaffold2})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minHeight: (screenWidth > 1035) ? screenHeight-150 : screenHeight-100,
      }} >
      <div style={{fontSize: '2em', fontWeight: 900, padding: '20px'}}>
        Get Free Quote
      </div>
      <div>
        <ConfigProvider
          theme={{
            algorithm: [
              theme.darkAlgorithm,
              // theme.compactAlgorithm
            ],
            ...FormTheme
          }} >
          <Space 
            style={{
              padding: '35px 50px 0 50px',
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              borderRadius: "10px",
            }}>
            {(!showResult) ?
              <QuoteForm
                form={form}
                isPurchaseDateDisabled={isPurchaseDateDisabled}
                isRentalDateDisabled={isRentalDateDisabled}
                loadings={loadings}
                isPurchase={isPurchase}
                isSingleWidth={isSingleWidth}
                screenWidth={screenWidth}
                breakpoint={breakpoint}
                toggleWidth={toggleWidth}
                onEquiryRadioChange={onEquiryRadioChange}
                onCheckboxPurchaseChange={onCheckboxPurchaseChange}
                onCheckboxRentalChange={onCheckboxRentalChange}
                onFinish={onFinish}
                // Services props
                isTransportationChecked={isTransportationChecked}
                isAssemblyDismantleChecked={isAssemblyDismantleChecked}
                isEndorsementChecked={isEndorsementChecked}
                siteAddress={siteAddress}
                onTransportationChange={onTransportationChange}
                onAssemblyDismantleChange={onAssemblyDismantleChange}
                onEndorsementChange={onEndorsementChange}
                onSiteAddressChange={onSiteAddressChange} /> :
              (isSuccess) ?
                <Result
                  status="success"
                  title="We've received your request!"
                  subTitle="We do our best to respond in 1 business day"
                  extra={[
                    <Button type="primary" key="request" onClick={toggleShowResult}>
                      Submit another request
                    </Button>,
                  ]}
                /> :
                <Result
                  status="error"
                  title="Submission Failed"
                  subTitle="Please refresh the page and try again"
                  extra={[]}
                />
            }

          </Space>
        </ConfigProvider>
      </div>
    </div>
  );
};
export default GetQuote;
